import React from "react";
import Layout from "../Layout";
import HeaderEmails from "./HeaderEmails";
import ListEmails from "./ListEmails";
import AddOrgEmail from "../shared/AddOrgEmail";

import useUserStore from "../../utils/storeApp";

const Emails = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
      <HeaderEmails />
      <ListEmails />
      <AddOrgEmail />
    </Layout>
  );
};

Emails.defaultProps = {};

export default Emails;
